"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROMPT_FILE_PURPOSE_TO_OPEN_AI = exports.PromptFilePurpose = exports.PromptResponseFormat = exports.PromptStatus = exports.TemplateVariableModelName = void 0;
/**
 * These are the names of the template variables
 * that can be injected into an HTML template
 */
var TemplateVariableModelName;
(function (TemplateVariableModelName) {
    TemplateVariableModelName["CustomField"] = "customField";
    TemplateVariableModelName["BusinessEntity"] = "businessEntity";
    TemplateVariableModelName["BusinessEntities"] = "businessEntities";
    TemplateVariableModelName["DataCategory"] = "dataCategory";
    TemplateVariableModelName["DataCategories"] = "dataCategories";
    TemplateVariableModelName["Vendor"] = "vendor";
    TemplateVariableModelName["Vendors"] = "vendors";
    TemplateVariableModelName["DataSilo"] = "dataSilo";
    TemplateVariableModelName["DataSilos"] = "dataSilos";
    TemplateVariableModelName["ProcessingPurpose"] = "processingPurpose";
    TemplateVariableModelName["ProcessingPurposes"] = "processingPurposes";
    TemplateVariableModelName["DataPointProperty"] = "dataPointProperty";
    TemplateVariableModelName["DataPointObject"] = "dataPointObject";
    TemplateVariableModelName["DataReport"] = "dataReport";
})(TemplateVariableModelName || (exports.TemplateVariableModelName = TemplateVariableModelName = {}));
/** Prompt status types */
var PromptStatus;
(function (PromptStatus) {
    PromptStatus["Draft"] = "DRAFT";
    PromptStatus["Submitted"] = "SUBMITTED";
    PromptStatus["InReview"] = "IN_REVIEW";
    PromptStatus["ChangesRequested"] = "CHANGES_REQUESTED";
    PromptStatus["Rejected"] = "REJECTED";
    PromptStatus["Approved"] = "APPROVED";
})(PromptStatus || (exports.PromptStatus = PromptStatus = {}));
/**
 * The response format of a LLM prompt
 */
var PromptResponseFormat;
(function (PromptResponseFormat) {
    PromptResponseFormat["Text"] = "text";
    PromptResponseFormat["JsonObject"] = "json_object";
    PromptResponseFormat["JsonSchema"] = "json_schema";
})(PromptResponseFormat || (exports.PromptResponseFormat = PromptResponseFormat = {}));
/**
 * The purpose for uploading a file to a prompt or agent
 */
var PromptFilePurpose;
(function (PromptFilePurpose) {
    PromptFilePurpose["Assistants"] = "ASSISTANTS";
    PromptFilePurpose["FineTune"] = "FINE_TUNE";
    PromptFilePurpose["FineTuneResults"] = "FINE_TUNE_RESULTS";
    PromptFilePurpose["AssistantsOutput"] = "ASSISTANTS_OUTPUT";
})(PromptFilePurpose || (exports.PromptFilePurpose = PromptFilePurpose = {}));
exports.PROMPT_FILE_PURPOSE_TO_OPEN_AI = {
    [PromptFilePurpose.Assistants]: 'assistants',
    [PromptFilePurpose.AssistantsOutput]: 'assistants_output',
    [PromptFilePurpose.FineTune]: 'fine-tune',
    [PromptFilePurpose.FineTuneResults]: 'fine-tune-results',
};
//# sourceMappingURL=prompt.js.map